<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Rating Config</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Rating Config</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <a
              href="javascript:void(0)"
              v-if="enableSearch == true"
              class="btn btn-info"
              @click="showFilter = !showFilter"
              ><i class="fa fa-filter"></i>Filter</a
            >
            <div class="card-tools">
              <router-link
                v-if="actionCreate == true"
                :to="{ name: 'RatingConfigAdd' }"
                class="btn btn-success"
              >
                <i class="fas fa-plus"></i> New
              </router-link>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <div class="card-body p-0" v-if="enableSearch == true">
            <form @submit.prevent="getList()" method="GET" novalidate>
              <div class="card-body" v-if="showFilter">
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group form-row">
                      <label class="col-form-label col-3">ID</label>
                      <div class="col-9">
                        <input
                          class="form-control id"
                          type="text"
                          name="id"
                          v-model="filter.id"
                          placeholder="ID"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-10 offset-1">
                    <button type="submit" class="btn btn-common m-2px">
                      <i class="fas fa-search"></i> Search
                    </button>
                    <button
                      type="reset"
                      class="btn btn-warning"
                      @click="resetFilter()"
                    >
                      <i class="fas fa-undo"></i> Reset
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Rating-Plan</th>
                    <th>Activation Start</th>
                    <th>Activation End</th>
                    <th>Priority</th>
                    <th>Rating Type</th>
                    <th>Rate Amount</th>
                    <th>Max Rate Amount</th>
                    <th>Currency</th>
                    <th>App-ID</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody class="list">
                  <tr v-for="(val, index) in list.data" :key="index">
                    <td>{{ val.id }}</td>
                    <td>{{ val.name }}</td>
                    <td>{{ val.description }}</td>
                    <td>{{ val.status }}</td>
                    <td>{{ val.rating_type_id }}</td>
                    <td>{{ val.activation_start }}</td>
                    <td>{{ val.activation_end }}</td>
                    <td>{{ val.priority }}</td>
                    <td>{{ val.rating_type_id }}</td>
                    <td>{{ val.rate }}</td>
                    <td>{{ val.max_rate_amount }}</td>
                    <td>{{ val.currency }}</td>
                    <td>{{ val.app_id }}</td>
                    <td class="text-right">
                      <router-link
                        v-if="actionView == true"
                        :to="{
                          name: 'RatingConfigShow',
                          params: { id: val.id },
                        }"
                        class="btn btn-info btn-sm m-2px"
                      >
                        <i class="fas fa-eye"></i>
                      </router-link>
                      <router-link
                        v-if="actionEdit == true"
                        :to="{
                          name: 'RatingConfigEdit',
                          params: { id: val.id },
                        }"
                        class="btn btn-info btn-sm m-2px"
                      >
                        <i class="fas fa-pencil-alt"></i>
                      </router-link>
                      <a
                        v-if="actionDelete == true"
                        class="btn btn-danger btn-sm m-2px"
                        href="javascript:void(0)"
                        @click="deleteObject(val.id, index)"
                        ><i class="fas fa-trash"></i
                      ></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="getList()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import { CBSProductRatingApi } from "@/services/api";

export default {
  name: "RatingConfig",
  components: {
    VuePagination,
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    },
    enableSearch: true,
    actionCreate: true,
    actionView: true,
    actionEdit: true,
    actionDelete: false,
    showFilter: false,
    filter: {},
    pre: [],
    is_loading: false,
    empty: false,
    empty_message: "",
  }),
  mounted: function () {
    this.getList();
  },
  methods: {
    getList: function () {
      this.is_loading = true;
      CBSProductRatingApi.getRatingConfig(
        this.list.current_page,
        this.filter,
        this.list.per_page
      )
        .then((items) => {
          this.list = items;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.getList();
    },
  },
};
</script>
